<template>
  <v-tooltip max-width="500" top>
    <template v-slot:activator="{ on }">
      <v-chip
        v-if="avaliando"
        color="secondary"
        class="mx-2"
        outlined
        small
      >
        <v-icon class="mr-2" small>wifi_protected_setup</v-icon>
        Avaliando
      </v-chip>
      <v-chip
        v-else-if="status"
        color="success"
        class="mx-2"
        outlined
        small
      >
        <v-icon class="mr-2" small>check</v-icon>
        Avaliação Finalizada
      </v-chip>
      <v-chip
        v-else
        color="warning"
        class="mx-2"
        outlined
        small
        v-on="on"
      >
        <v-icon class="mr-2" small>warning</v-icon>
        Avaliação Não Finalizada
      </v-chip>
    </template>
    <span>Clique na opção FINALIZAR no final da página para que a avaliação seja válida</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'AvaliacaoStatus',

  props: {
    avaliando: {
      type: Boolean,
      required: true,
      default: false,
    },
    status: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
};
</script>
